import React, { useEffect, useState } from "react";
import api from "../api";

export default function ProductTypeMaster() {

  const [list, setList] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [form, setForm] = useState({
    name: "",

    // LOAD FIELDS
    base_rate: "",
    base_cases: "",
    case_over_rate: "",
    base_sorts: "",
    sort_over_rate: "",
    weight_case_threshold: "",
    overweight_charge: "",
    pallet_base: "",
    pallet_bonus: "",

    // EMPLOYEE FIELDS
    employee_min_payout: "",
    employee_upto_case_count: "",
    addl_payout_case: "",
    upto_sort_count: "",
    employee_additional_payout_sort: "",
    addl_payout_weight: "",
    hourly_rate: "",
    hourly_bonus: "",
    flat_bonus: "",
  });

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const res = await api.get("/product-types");
      setList(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load product types");
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const reset = () => {

    setEditingId(null);

    setForm({
      name: "",

      base_rate: "",
      base_cases: "",
      case_over_rate: "",
      base_sorts: "",
      sort_over_rate: "",
      weight_case_threshold: "",
      overweight_charge: "",
      pallet_base: "",
      pallet_bonus: "",

      employee_min_payout: "",
      employee_upto_case_count: "",
      addl_payout_case: "",
      upto_sort_count: "",
      employee_additional_payout_sort: "",
      addl_payout_weight: "",
      hourly_rate: "",
      hourly_bonus: "",
      flat_bonus: "",
    });
  };

  const submit = async (e) => {

    e.preventDefault();

    try {

      if (editingId) {
        await api.put(`/product-types/${editingId}`, form);
        alert("Updated successfully");
      } else {
        await api.post("/product-types", form);
        alert("Created successfully");
      }

      await load();
      reset();

    } catch (err) {
      console.error(err);
      alert("Error: " + JSON.stringify(err.response?.data || err.message));
    }
  };

  const handleEdit = (pt) => {

    setEditingId(pt.id);

    setForm({
      name: pt.name || "",

      // LOAD
      base_rate: pt.base_rate || "",
      base_cases: pt.base_cases || "",
      case_over_rate: pt.case_over_rate || "",
      base_sorts: pt.base_sorts || "",
      sort_over_rate: pt.sort_over_rate || "",
      weight_case_threshold: pt.weight_case_threshold || "",
      overweight_charge: pt.overweight_charge || "",
      pallet_base: pt.pallet_base || "",
      pallet_bonus: pt.pallet_bonus || "",

      // EMPLOYEE
      employee_min_payout: pt.employee_min_payout || "",
      employee_upto_case_count: pt.employee_upto_case_count || "",
      addl_payout_case:pt.employee_additional_payout_case || "",
      upto_sort_count: pt.employee_upto_sort_count || "",
      employee_additional_payout_sort:
        pt.employee_additional_payout_sort || "",
      addl_payout_weight: pt.addl_payout_weight || "",
      hourly_rate: pt.hourly_rate || "",
      hourly_bonus: pt.hourly_bonus || "",
      flat_bonus: pt.flat_bonus || "",
    });
  };

  const handleDelete = async (id) => {

    if (!window.confirm("Delete this product type?")) return;

    try {
      await api.delete(`/product-types/${id}`);
      await load();
    } catch {
      alert("Delete failed");
    }
  };

  return (
    <div className="container mt-3">

      <div className="mx-auto" style={{ maxWidth: "1200px" }}>

        <h3 className="mb-3">
          📦 Product Types / Wage Rules
        </h3>

        <form onSubmit={submit}>

          {/* ================= LOAD FIELDS ================= */}

          <div className="card p-3 mb-3 shadow-sm">

            <h5 className="mb-3">🚚 Load Fields</h5>

            <div className="row g-2">

              <div className="col-12 col-md-4">
                <input
                  name="name"
                  className="form-control"
                  placeholder="Name"
                  required
                  value={form.name}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-2">
                <input
                  name="base_rate"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Base Rate"
                  value={form.base_rate}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-2">
                <input
                  name="base_cases"
                  type="number"
                  className="form-control"
                  placeholder="Base Cases"
                  value={form.base_cases}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-2">
                <input
                  name="case_over_rate"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Case Over"
                  value={form.case_over_rate}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-2">
                <input
                  name="base_sorts"
                  type="number"
                  className="form-control"
                  placeholder="Base Sorts"
                  value={form.base_sorts}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-2">
                <input
                  name="sort_over_rate"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Sort Over"
                  value={form.sort_over_rate}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-3">
                <input
                  name="weight_case_threshold"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Weight Threshold"
                  value={form.weight_case_threshold}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-3">
                <input
                  name="overweight_charge"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Overweight Charge"
                  value={form.overweight_charge}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-3">
                <input
                  name="pallet_base"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Pallet Base"
                  value={form.pallet_base}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-3">
                <input
                  name="pallet_bonus"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Pallet Bonus"
                  value={form.pallet_bonus}
                  onChange={handleChange}
                />
              </div>

            </div>

          </div>

          {/* ================= EMPLOYEE FIELDS ================= */}

          <div className="card p-3 mb-3 shadow-sm">

            <h5 className="mb-3">👷 Employee Fields</h5>

            <div className="row g-2">

              <div className="col-6 col-md-3">
                <input
                  name="employee_min_payout"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Min Payout"
                  value={form.employee_min_payout}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-3">
                <input
                  name="employee_upto_case_count"
                  type="number"
                  className="form-control"
                  placeholder="Up To Cases"
                  value={form.employee_upto_case_count}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-3">
                <input
                  name="addl_payout_case"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="$/Case"
                  value={form.addl_payout_case}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-3">
                <input
                  name="upto_sort_count"
                  type="number"
                  className="form-control"
                  placeholder="Up To Sorts"
                  value={form.upto_sort_count}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-3">
                <input
                  name="employee_additional_payout_sort"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="$/Sort"
                  value={form.employee_additional_payout_sort}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-3">
                <input
                  name="addl_payout_weight"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Weight Bonus"
                  value={form.addl_payout_weight}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-2">
                <input
                  name="hourly_rate"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Hourly Rate"
                  value={form.hourly_rate}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 col-md-2">
                <input
                  name="hourly_bonus"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Hourly Bonus"
                  value={form.hourly_bonus}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 col-md-2">
                <input
                  name="flat_bonus"
                  type="number"
                  step="0.01"
                  className="form-control"
                  placeholder="Flat Bonus"
                  value={form.flat_bonus}
                  onChange={handleChange}
                />
              </div>

            </div>

          </div>

          {/* ================= BUTTONS ================= */}

          {/* MOBILE */}
          <div className="d-md-none fixed-bottom bg-white p-2 border-top shadow">
            <button className="btn btn-primary w-100">
              {editingId ? "Update Product Type" : "Create Product Type"}
            </button>
          </div>

          {/* DESKTOP */}
          <div className="d-none d-md-flex justify-content-center gap-2 mb-4">

            <button className="btn btn-primary px-4">
              {editingId ? "Update" : "Create"}
            </button>

            {editingId && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={reset}
              >
                Cancel
              </button>
            )}

          </div>

          <div className="d-md-none" style={{ height: "70px" }}></div>

        </form>

        <hr />

        <h4 className="mb-3">Existing Product Types</h4>

        {/* DESKTOP TABLE */}
        <div className="d-none d-md-block">

          <table className="table table-bordered table-hover">

            <thead className="table-light">
              <tr>
                <th>Name</th>
                <th>Min Payout</th>
                <th>Case Rule</th>
                <th>Sort Rule</th>
                <th>Weight Rule</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {list.map((pt) => (
                <tr key={pt.id}>

                  <td>{pt.name}</td>

                  <td>
                    {pt.employee_min_payout || "—"}
                  </td>

                  <td>
                    Up to {pt.employee_upto_case_count || "—"} |
                    +{pt.employee_additional_payout_case || "—"}
                  </td>

                  <td>
                    Up to {pt.employee_upto_sort_count || "—"} |
                    +{pt.employee_additional_payout_sort || "—"}
                  </td>

                  <td>
                    {pt.weight_case_threshold || "—"} lbs |
                    ${pt.overweight_charge || "—"}
                  </td>

                  <td>

                    <button
                      className="btn btn-sm btn-warning me-2"
                      onClick={() => handleEdit(pt)}
                    >
                      Edit
                    </button>

                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(pt.id)}
                    >
                      Delete
                    </button>

                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

        {/* MOBILE CARDS */}
        <div className="d-md-none">

          {list.map((pt) => (
            <div
              key={pt.id}
              className="card p-3 mb-2 shadow-sm"
            >

              <strong>{pt.name}</strong>

              <div className="small mt-1">
                Min: {pt.employee_min_payout || "—"}
              </div>

              <div className="small">
                Case: {pt.employee_upto_case_count || "—"} |
                +{pt.employee_additional_payout_case || "—"}
              </div>

              <div className="small">
                Sort: {pt.employee_upto_sort_count || "—"} |
                +{pt.employee_additional_payout_sort || "—"}
              </div>

              <div className="small">
                Weight: {pt.weight_case_threshold || "—"} lbs
              </div>

              <div className="d-flex gap-2 mt-3">

                <button
                  className="btn btn-sm btn-warning w-50"
                  onClick={() => handleEdit(pt)}
                >
                  Edit
                </button>

                <button
                  className="btn btn-sm btn-danger w-50"
                  onClick={() => handleDelete(pt.id)}
                >
                  Delete
                </button>

              </div>

            </div>
          ))}

        </div>

      </div>

    </div>
  );
}